import React, { useEffect } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";

import withAuthRequired from "../components/hoc/withAuthRequired";
import Layout from "../components/common/Layout";
import Loader from "../components/common/Loader";
import JobCard from "../components/job-card";
import Label from "../components/label";
import ReportPrinter from "../components/report-printer";
import Signin from "../pages/signin";
import { isAuthenticated } from "../utils";

//ROUTES
import Users from "../pages/admin/users";
import Branches from "../pages/admin/branches";
import Procedures from "../pages/admin/procedures";
import Scheduler from "../pages/scheduler.jsx";
import CreatePatient from "../pages/create-patient";
import CreateStudy from "../pages/create-study";
import EditStudy from "../pages/edit-study";
import Worklist from "../pages/worklist";
import RefDocWorklist from "../pages/ref-doc-worklist";
import NotFound from "../pages/not-found";
import CreatePayment from "../pages/cash-payment";

// const Users = React.lazy(() => import("../pages/admin/users"));
// const Branches = React.lazy(() => import("../pages/admin/branches"));
// const Procedures = React.lazy(() => import("../pages/admin/procedures"));
// const Scheduler = React.lazy(() => import("../pages/scheduler.jsx"));
// const CreatePatient = React.lazy(() => import("../pages/create-patient"));
// const CreateStudy = React.lazy(() => import("../pages/create-study"));
// const EditStudy = React.lazy(() => import("../pages/edit-study"));
// const Worklist = React.lazy(() => import("../pages/worklist"));
// const RefDocWorklist = React.lazy(() => import("../pages/ref-doc-worklist"));
// const NotFound = React.lazy(() => import("../pages/not-found"));

const Routes = () => {
  useEffect(() => {
    document.title = "Login";
    const currentPath = window.location.pathname;
    if (!isAuthenticated() && !(currentPath === "/login")) {
      window.location.href = "/login";
    }
  }, []);

  return (
    <React.Suspense fallback={<Loader />}>
      <Router>
        <Switch>
          <Route exact path="/login" component={Signin} />
          <Route exact path="/job-card" component={JobCard} />
          <Route exact path="/label" component={Label} />
          <Route exact path="/report-printer" component={ReportPrinter} />
          <Layout>
            <Route
              path="/ref-doctor-worklist"
              component={withAuthRequired(RefDocWorklist)}
            />

            <Route path="/" exact component={withAuthRequired(Scheduler)} />
            {/* <Route path="/scheduler" component={withAuthRequired(Scheduler)} /> */}
            <Route path="/users" component={withAuthRequired(Users)} />
            <Route path="/branches" component={withAuthRequired(Branches)} />
            <Route path="/worklist" component={withAuthRequired(Worklist)} />
            <Route path="/my-worklist" component={withAuthRequired(Worklist)} />
            <Route path="/cash-payment" component={withAuthRequired(CreatePayment)} />

            <Route path="/reporting" component={withAuthRequired(NotFound)} />
            <Route
              path="/patient"
              component={withAuthRequired(CreatePatient)}
            />
            <Route
              path="/edit-patient"
              component={withAuthRequired(CreatePatient)}
            />
            <Route
              path="/procedures"
              component={withAuthRequired(Procedures)}
            />
            <Route path="/study" component={withAuthRequired(CreateStudy)} />
            <Route path="/edit-study" component={withAuthRequired(EditStudy)} />

            <Route path="/pacs" component={withAuthRequired(NotFound)} />
          </Layout>
        </Switch>
      </Router>
    </React.Suspense>
  );
};

export default Routes;
